export const STRIPE_PUBLIC_KEY =
	"pk_test_51QZrAQH1aeFjzv3vaq7ffg94qg990G72S6yD2L029L00RjL51UDAFDE2fky5dvvPAJ9Bg5WjGj6LUUtplFNwFdK400NGJUs2ZK";
export const MOCK_CLIENT_SECRET =
	"pi_3Mc7yrLkdIwHu7ix0vgMYKLq_secret_ym1QQRopBAAV4rL9RyxlvQR2t";
